import { SelectOption } from "@/rca-types";
import {
  CaseRiskColors,
  CaseStatusColors,
  CaseStatusDef,
  CaseStatusType,
  CaseStatusValue,
  CaseType,
  ExplanationFraud,
  ExplanationNotFraud,
  RiskScore,
  ICaseStore
} from "@/types/casesFrontendTypes";
import {
  CaseResultDef,
  CaseResultDefControl
} from "../../../rca-app-server/src/cases/casesTypes";

export const CASE_INVESTIGATION_RESULT_CODE = {
  FRAUD: "FRAUD",
  NOT_FRAUD: "NOT_FRAUD"
};

export const CASE_INVESTIGATION_RESULT: CaseResultDef = {
  FRAUD: "Fraudulent",
  NOT_FRAUD: "Not Fraudulent"
};

export const CASE_INVESTIGATION_RESULT_CONTROL: CaseResultDefControl = {
  FRAUD: "Substantiated",
  NOT_FRAUD: "Non-substantiated"
};

export const CASE_INVESTIGATION_RESULT_EXPLANATION: ExplanationNotFraud &
  ExplanationFraud = {
  // NOT_FRAUD: {
  coworker_error: [
    "Co-worker error",
    "Errors or mistakes were caused by an employee by accident."
  ],
  coworker_in_training: [
    "Co-worker in training",
    "Errors or mistakes were caused by a new co-worker who is still in training."
  ],
  genuine_transaction: [
    "Genuine transaction",
    "The transaction was correctly executed."
  ],
  incorrect_code: [
    "Incorrect reason code identification",
    "The identified reason code is incorrect. Different activity happened."
  ],
  other: [
    "Other",
    "None of the above options are suitable for the explanation how this happened."
  ],
  store_workaround: [
    "Store workaround",
    "Internal store workaround to be able to execute such transaction."
  ],
  system_error: [
    "System error",
    "Technical issues or errors during the transaction."
  ],
  incorrect_explanation: [
    "Incorrect close reason explanation",
    "Incorrect close reason explanation"
  ],
  additional_info: [
    "Additional information found on case",
    "Additional information found on case"
  ],
  // },
  // FRAUD: {
  correct_code: [
    "Reason code was correctly identified",
    "The identified reason code is correct and explains correctly what happened."
  ],
  different_code: [
    "Different reason code or activity",
    "The identified reason code is incorrect. Different activity happened and new reason code needs to be selected."
  ]

  // },
};

export const CASE_STATUSES: Omit<
  CaseStatusDef,
  "OVERDUE" | "INVESTIGATING_CONTROL" | "INREVIEW" | "REOPENED" | "CHECK_LATER"
> = {
  NEW: "New case",
  ASSIGNED: "Assigned",
  INVESTIGATING: "Under investigation",
  CLOSED: "Closed"
};

export const STATUS_API_RESPONSE = {
  new: "new",
  inReview: "inReview",
  closed: "closed",
  checkLater: "checkLater",
  overdueReviewer: "overdueReviewer",
  overduePerformer: "overduePerformer"
};

export const RiskLevelColor: Record<RiskScore, CaseRiskColors> = {
  HIGH: "rcaRiskRed",
  LOW: "rcaRiskYellow",
  MEDIUM: "rcaRiskOrange"
};

export const RiskLevel: Record<RiskScore, string> = {
  HIGH: "High risk",
  LOW: "Low risk",
  MEDIUM: "Medium risk"
};

export const RiskPattern: Record<CaseType, string> = {
  bank: "Bank refunds",
  card: "Card refunds",
  disc: "Co-worker discounts",
  sams: "SAMS user refunds",
  void: "Voiding behavior"
};

export const CaseStatus: Record<CaseStatusType, CaseStatusValue> = {
  ASSIGNED: "Assigned",
  OVERDUE: "Overdue",
  NEW: "New case",
  INVESTIGATING: "Under investigation",
  CLOSED: "Closed",
  REOPENED: "Re-opened",
  INVESTIGATING_CONTROL: "Under Investigation",
  INREVIEW: "In Review",
  CHECK_LATER: "Check later"
};

export const CaseStatusColor: Record<CaseStatusType, CaseStatusColors> = {
  ASSIGNED: "rcaStatusBlue",
  OVERDUE: "rcaStatusRed",
  NEW: "rcaStatusGray",
  INVESTIGATING: "rcaStatusPink",
  REOPENED: "rcaStatusPink",
  INVESTIGATING_CONTROL: "rcaStatusPink",
  CLOSED: "rcaStatusGreen",
  INREVIEW: "rcaStatusYellow",
  CHECK_LATER: "rcaStatusPink"
};

export const StatsKind: Record<CaseStatusType, CaseStatusValue> = {
  ASSIGNED: "Assigned",
  OVERDUE: "Overdue",
  NEW: "New case",
  INVESTIGATING: "Under investigation",
  REOPENED: "Re-opened",
  INVESTIGATING_CONTROL: "Under Investigation",
  CLOSED: "Closed",
  INREVIEW: "In Review",
  CHECK_LATER: "Check later"
};

export const RolesToAccessReports: string[] = [
  "CountryRiskManager",
  "CashierRiskManager",
  "CustomerSupportRiskManager",
  "GlobalRiskManager",
  "Admin"
];

export const ManagerialRoles: string[] = [
  "CountryRiskManager",
  "CashierRiskManager",
  "CustomerSupportRiskManager",
  "GlobalRiskManager",
  "StoreRiskManager",
  "Admin"
];

export const NoAssociatedStore: ICaseStore = {
  store_code: "000",
  store_name: "No associated unit/store"
};

export const ReOpenReasons: SelectOption[] = [
  {
    text: "Incorrectly closed",
    value: "incorrect_explanation"
  },
  {
    text: "Additional information found on case",
    value: "additional_info"
  }
];
export const TableConstants = {
  no_data_card: "Possible receiptless return",
  no_data_default: "No data available"
};

export const RolesToAccessRiskControls: string[] = [
  "RiskControlsCo-worker",
  "RiskControlsS&STeam-member"
];

export const RolesToAccessRiskControlsCoWorker: string[] = [
  "RiskControlsCo-worker"
];

export const RolesToAccessRiskControlsReviewer: string[] = [
  "RiskControlsS&STeam-member"
];

export const RolesToAccessRiskControlsReports: string[] = [
  "RiskControlsReportingGlobalLevelAccess",
  "RiskControlsReportingStoreLevelAccess",
  "RiskControlsReportingCountryLevelAccess"
];

export const RolesToAccessRiskPatterns: string[] = [
  "CountryRiskManager",
  "CashierRiskManager",
  "CustomerSupportRiskManager",
  "StoreRiskManager",
  "StoreRiskCo-worker",
  "CustomerSupportRiskCo-worker",
  "CashierRiskCo-worker",
  "GlobalRiskManager",
  "Admin"
];

export enum RiskControlAdRole {
  tend = "Tender Deviations"
}

export enum RiskScorePayload {
  high = "High",
  low = "Low",
  medium = "Medium"
}

export const Unassigned = [{ name: "Unassigned", id: "1" }];

export const AdRoles: any = {
  "RiskControlsCo-worker": "Control performer",
  "RiskControlsS&STeam-member": "Control reviewer",
  CountryRiskManager: "Country risk manager",
  Admin: "Admin",
  CashierRiskManager: "Cashier risk manager",
  CustomerSupportRiskManager: "Customer support risk manager",
  GlobalRiskManager: "Global risk manager",
  StoreRiskManager: "Store risk manager",
  "CashierRiskCo-worker": "Cashier risk co-worker",
  "CustomerSupportRiskCo-worker": "Customer support risk co-worker",
  "StoreRiskCo-worker": "Store risk co-worker",
  AMLReportingStoreLevelAccess: "AML reporting store level",
  AMLReportingCountryLevelAccess: "AML reporting country level",
  AMLReportingGlobalLevelAccess: "AML reporting global level"
};

export const RISK_LEVEL = "risk_levels";
export const CONTROLS_SORT_BY = {
  RISK_LEVEL
};

export const DATE_RANGE_OPTIONS = {
  ONE_YEAR_TEXT: "1 year back",
  ONE_YEAR_VALUE: "1 year",
  LAST_24_HRS_TEXT: "last 24 hours",
  LAST_24_HRS_VALUE: "24 hours",
  ONE_WEEK_TEXT: "1 week back",
  ONE_WEEK_VALUE: "1 week",
  TWO_WEEK_TEXT: "2 weeks back",
  TWO_WEEK_VALUE: "2 weeks",
  ONE_MONTH_TEXT: "1 month back",
  ONE_MONTH_VALUE: "1 month",
  THREE_MONTHS_TEXT: "3 months back",
  THREE_MONTHS_VALUE: "3 months",
  SIX_MONTHS_TEXT: "6 months back",
  SIX_MONTHS_VALUE: "6 months"
};

export const AMOUNT_RANGE_OPTIONS = {
  LESS_THAN_100_TEXT: "Below 100",
  LESS_THAN_100_VALUE: "< 100",
  RANGE_100_TO_200_TEXT: "101 - 499",
  RANGE_100_TO_200_VALUE: "101 - 499",
  RANGE_500_TO_999_TEXT: "500 - 999",
  RANGE_500_TO_999_VALUE: "500 - 999",
  MORE_THAN_1000_TEXT: "Above 1000",
  MORE_THAN_1000_VALUE: "> 1000"
};

export const RC = {
  TD_CODE: "TENDER_DEVIATION",
  TD_ROUTE_PARAM: "tender-deviations",
  TD_DESC: "Tender Deviations",
  ANA_CODE: "ARTICLE_NON_ARTICLE_COMPENSATION",
  ANA_ROUTE_PARAM: "article-non-article",
  ANA_DESC: "Article/Non-Article Compensation",
  AC_DESC: "Article Compensation",
  NAC_DESC: "Non-Article Compensation",
  AC_CODE: "ARTICLE_COMPENSATION_CONTROL",
  NAC_CODE: "NON_ARTICLE_COMPENSATION_CONTROL",
  RR_ROUTE_PARAM: "receiptless-returns",
  RR_DESC: "Receiptless Returns",
  RR_CODE: "RECEIPTLESS_CONTROL",
  RPA_ROUTE_PARAM: "return-price-adjustments",
  RPA_DESC: "Return price adjustments",
  RPA_CODE: "RETURN_PRICE_ADJUSTMENT_CONTROL",
  SG80_ROUTE_PARAM: "sales-group-80",
  SG80_DESC: "Sales group 80",
  SG80_CODE: "SALES_GROUP_80_CONTROL"
};

export const RiskControlsRouteParamMap = {
  [RC.TD_ROUTE_PARAM]: RC.TD_DESC,
  [RC.ANA_ROUTE_PARAM]: RC.ANA_DESC,
  [RC.RR_ROUTE_PARAM]: RC.RR_DESC,
  [RC.RPA_ROUTE_PARAM]: RC.RPA_DESC,
  [RC.SG80_ROUTE_PARAM]: RC.SG80_DESC
};

export const RiskControlsCodeMap = {
  [RC.TD_CODE]: RC.TD_DESC,
  [RC.ANA_CODE]: RC.ANA_DESC,
  [RC.AC_CODE]: RC.ANA_DESC,
  [RC.NAC_CODE]: RC.ANA_DESC,
  [RC.RR_CODE]: RC.RR_DESC,
  [RC.RPA_CODE]: RC.RPA_DESC,
  [RC.SG80_CODE]: RC.SG80_DESC
};

export const RiskControlsCompensationTypes = {
  [RC.AC_CODE]: RC.AC_DESC,
  [RC.NAC_CODE]: RC.NAC_DESC
};

export const RiskControlsMap = [
  {
    routeParam: RC.TD_ROUTE_PARAM,
    description: RC.TD_DESC,
    code: [RC.TD_CODE]
  },
  {
    routeParam: RC.ANA_ROUTE_PARAM,
    description: RC.ANA_DESC,
    code: [RC.AC_CODE, RC.NAC_CODE]
  },
  {
    routeParam: RC.RR_ROUTE_PARAM,
    description: RC.RR_DESC,
    code: [RC.RR_CODE]
  },
  {
    routeParam: RC.RPA_ROUTE_PARAM,
    description: RC.RPA_DESC,
    code: [RC.RPA_CODE]
  },
  {
    routeParam: RC.SG80_ROUTE_PARAM,
    description: RC.SG80_DESC,
    code: [RC.SG80_CODE]
  }
];

export const TENDER_TYPE = {
  PURCHASE: "purchase",
  RETURN: "return"
};

export const AMOUNT_REFERENCE_LIST = [
  { text: "All", value: "" },
  {
    text: AMOUNT_RANGE_OPTIONS.LESS_THAN_100_TEXT,
    value: AMOUNT_RANGE_OPTIONS.LESS_THAN_100_VALUE
  },
  {
    text: AMOUNT_RANGE_OPTIONS.RANGE_100_TO_200_TEXT,
    value: AMOUNT_RANGE_OPTIONS.RANGE_100_TO_200_VALUE
  },
  {
    text: AMOUNT_RANGE_OPTIONS.RANGE_500_TO_999_TEXT,
    value: AMOUNT_RANGE_OPTIONS.RANGE_500_TO_999_VALUE
  },
  {
    text: AMOUNT_RANGE_OPTIONS.MORE_THAN_1000_TEXT,
    value: AMOUNT_RANGE_OPTIONS.MORE_THAN_1000_VALUE
  }
];

interface ILanguageServiceConfig {
  glsWidgetLoaderurl: string;
  allowedCountries: string[];
}

export const LANGUAGE_SERVICE_COFFIG: ILanguageServiceConfig = {
  glsWidgetLoaderurl: "https://wst.inten.to/wststatic/widgetLoader.js",
  allowedCountries: ["Country.DE", "Country.FR", "Country.CA"]
};
